import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../../src/appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from "../../src/core/rest";

export const GetUserGroups = createAsyncThunk(
  "UserGroups/GetUserGroups",
  async (user_request) => {
    try {
      const response = await Rest.get(
        ApiGatewayUrl + "/usergroups?page_no=" + user_request.page_no + 
        "&rows_per_page=" + user_request.rows_per_page + 
        "&agency_id=" + user_request.agency_id + 
        "&searchName=" + user_request.searchName
      );
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }

  }
);
export const GetMemberList = createAsyncThunk(
  "UserGroups/GetMemberList",
  async (user_request) => {
    try {
      let roles = '';
      if (user_request.roles.length > 0) {
        roles = user_request.roles.join(',');
      }
      const response = await Rest.get(
        ApiGatewayUrl +
        "/usergroups/getMembers?page_no=" +
        user_request.page_no + "&rows_per_page=" +
        user_request.rows_per_page + "&gp_id=" +
        user_request.gp_id
        + "&roles=" + roles
        + "&searchEmail=" + user_request.searchEmail
        + "&filteredEmail=" + user_request.filteredEmail
      );
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const CreateUserGroup = createAsyncThunk(
  "UserGroups/CreateUserGroup",
  async (data) => {
    try {
      const response = await Rest.post(
        ApiGatewayUrl + '/usergroups', data
      );
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const RenameAndUpdateUserGroup = createAsyncThunk(
  "UserGroups/RenameUserGroup",
  async (data) => {
    try {
      const response = await Rest.put(
        ApiGatewayUrl + '/usergroups', data
      );
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }

  }
);
export const DeleteUserGroup = createAsyncThunk(
  "UserGroups/DeleteUserGroup",
  async (id) => {
    try {
      const respond = await Rest.delete(ApiGatewayUrl + "/usergroups/" + id)
      return respond.data;
    } catch (ex) {
      ErrorException(ex.response);
    }

  }
);
export const RemoveUserMember = createAsyncThunk(
  "UserGroups/RemoveUserMember",
  async (id) => {
    try {
      const response = await Rest.delete(ApiGatewayUrl + "/usergroups/remove/" + id)
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }

  }
)
export const userGroupSlice = createSlice({
  name: "userGroup",
  initialState: {
    usergroups: [],
    isLoading: false,
    total: 0,
    usergroup: {},
    usergroupMember: [],
    renamedUserGroup: {},
    selectedAgencyId: 0,
    users: [],
    roles: [],
    filterMembers: {},
    isRenaming: false,
  },
  reducers: {
    updateAgency: (state, action) => {
      state.selectedAgencyId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetUserGroups.pending, (state) => {
        return { ...state, isLoading: true };
      })
      .addCase(GetUserGroups.fulfilled, (state, action) => {
        return {
          ...state,
          usergroups: action.payload.usergroups,
          total: action.payload.total, 
          isLoading: false
        };
      })
      .addCase(GetMemberList.fulfilled, (state, action) => {
        return {
          ...state,
          usergroupMember: action.payload.groupMembers,
          total: action.payload.total,
          usergroup: action.payload.usergroup,
          users: action.payload.users,
          roles: action.payload.roles,
          isLoading: false
        };
      })
      .addCase(RenameAndUpdateUserGroup.pending, (state) => {
        return { ...state, isRenaming: true };
      })
      .addCase(RenameAndUpdateUserGroup.rejected, (state) => {
        return { ...state, isRenaming: true };
      })
    builder.addCase(RenameAndUpdateUserGroup.fulfilled, (state, action) => {
      return {
        ...state,
        renamedUserGroup: action.payload,
        isRenaming: false,
        isLoading: false
      };
    });
  }
});
export const userGroupActions = userGroupSlice.actions;
export const userGroupState = (state) => state.userGroup;
export default userGroupSlice.reducer;
